import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-airdisk-value-disclaimer',
  templateUrl: './airdisk-value-disclaimer.component.html',
  styleUrls: ['./airdisk-value-disclaimer.component.scss'],
  standalone: false
})
export class AirdiskValueDisclaimerComponent {

  privacyNotice: any;
  subscription = new Subscription();
  constructor(private readonly dialogRef: MatDialogRef<AirdiskValueDisclaimerComponent>, private readonly cmsService: CmsService) { }
  accept() {
    this.dialogRef.close(true);
  }
  ngOnInit() {
    this.subscription.add(this.cmsService.getComponentData('privayStatementNA').subscribe((data: any) => {
      if (data) {
        this.privacyNotice = data.content;
      }
    }));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
